// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpandableContent__container___PMSdz {
    --expandable-content-height: var(--expandable-content-base-height);

    display: flex;
    flex-direction: column;

    & .ExpandableContent__body___RT2p4 {
        overflow-y: auto;
        flex-grow: 1;

        /* Отображаемая высота контента это таргетная высота минус высота кнопки */
        height: calc(var(--expandable-content-height) - var(--space-m));
        transition: height 0.2s ease-in-out;
    }

    &.ExpandableContent__fullHeight___OIzVi {
        & .ExpandableContent__body___RT2p4 {
            --expandable-content-height: var(--expandable-content-expanded-height);
        }
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ExpandableContent/ExpandableContent.css"],"names":[],"mappings":"AAAA;IACI,kEAAkE;;IAElE,aAAa;IACb,sBAAsB;;IAEtB;QACI,gBAAgB;QAChB,YAAY;;QAEZ,0EAA0E;QAC1E,+DAA+D;QAC/D,mCAAmC;IACvC;;IAEA;QACI;YACI,sEAAsE;QAC1E;IACJ;AACJ","sourcesContent":[".container {\n    --expandable-content-height: var(--expandable-content-base-height);\n\n    display: flex;\n    flex-direction: column;\n\n    & .body {\n        overflow-y: auto;\n        flex-grow: 1;\n\n        /* Отображаемая высота контента это таргетная высота минус высота кнопки */\n        height: calc(var(--expandable-content-height) - var(--space-m));\n        transition: height 0.2s ease-in-out;\n    }\n\n    &.fullHeight {\n        & .body {\n            --expandable-content-height: var(--expandable-content-expanded-height);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ExpandableContent__container___PMSdz`,
	"body": `ExpandableContent__body___RT2p4`,
	"fullHeight": `ExpandableContent__fullHeight___OIzVi`
};
export default ___CSS_LOADER_EXPORT___;
